import { useTranslation } from 'react-i18next'
import { Card } from '#app/ui/components/custom/card'
import { Section } from '#app/ui/components/custom/section'
import { SectionHeader } from '#app/ui/components/custom/section-header'

type ServiceItem = { title: string; body: string }

export const Services = () => {
	const { t } = useTranslation('home')
	const services = t('services.items', {
		returnObjects: true,
	}) as ServiceItem[]

	return (
		<Section>
			<SectionHeader
				eyebrow={t('services.eyebrow')}
				heading={t('services.heading')}
				lead={t('services.lead')}
			/>
			<div className="mt-fluid-16 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
				{services.map(service => (
					<Card key={service.title} title={service.title} body={service.body} />
				))}
			</div>
		</Section>
	)
}
